import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.css'],
    standalone: false
})
export class PriceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
